__turbopack_context__.v({
  "wrapper": "FullWidth-module__ZNmYba__wrapper",
});
